import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../stores/authStore';
import { supabase } from '../lib/supabase';

export const useLanguageSync = () => {
  const { i18n, t } = useTranslation(); 
  const { user } = useAuthStore();
  
  // 1. Sync language logic
  useEffect(() => {
    const syncLanguage = async () => {
      if (user?.id) {
        if (user?.language) {
          const dbLanguage = user.language;
          localStorage.setItem('language', dbLanguage);

          if (i18n.language !== dbLanguage) {
            await i18n.changeLanguage(dbLanguage);
          }
        }
      } else {
        const storedLanguage = localStorage.getItem('language') || 'de';

        if (i18n.language !== storedLanguage) {
          await i18n.changeLanguage(storedLanguage);
        }
      }
    };

    syncLanguage();
  }, [user?.id]); 

  // 2. NEW: Global Document Title & HTML Lang Updater
  useEffect(() => {
    // Updates the browser tab title
    document.title = t('common.app.title', 'NutriBot - Dein persönlicher Ernährungscoach');
    
    // Updates the <html lang="de"> tag for SEO and accessibility
    document.documentElement.lang = i18n.language;
  }, [i18n.language, t]); // Re-runs whenever the language changes

  // 3. Change language handler
  const changeLanguage = async (newLanguage: 'en' | 'de') => {
    // Update i18n immediately
    await i18n.changeLanguage(newLanguage);

    // Update localStorage
    localStorage.setItem('language', newLanguage);

    // If authenticated, update profile DB
    if (user?.id) {
      try {
        await supabase
          .from('profiles')
          .update({ language: newLanguage })
          .eq('id', user.id);
      } catch (error) {
        // console.error('Failed to update language in profile:', error);
      }
    }
  };

  return { changeLanguage };
};